<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title> Ended Medications </v-card-title>
      <v-card-text>
        <div v-if="medications.length">
          The following medications have ended:
          <v-list dense>
            <v-list-item v-for="med in medications" :key="med.id">
              <v-list-item-content>
                <v-list-item-title>
                  {{ med.name }} (Ended: {{ med.endDate }})
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog"> Okay </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EndedMedicationsDialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    medications: {
      type: Array,
      required: true,
    },
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>
